export const SET_JOB_PAGE_SCROLL_Y = 'SET_JOB_PAGE_SCROLL_Y';

export const setJobPageScrollY = (value) => ({
  type: SET_JOB_PAGE_SCROLL_Y,
  jobPageScrollY: value,
});
